const allVouch = { data: [], loading: true };

export const GetAllUnSubmittedVouchers = (state = allVouch, action) => {
  switch (action.type) {
    case "get_unsubmittedVouch":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
const initialState = {
  loading: false,
  transactionData: [],
  taxDetails: [],
  debitTotal: 0,
  creditTotal: 0,
  voucherName: "",
  multiTransaction: false,
  error: null,
};

export const unsubmittedVoucherReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UNSUBMITTED_VOUCHER_DETAIL":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
